import SkipForwardIcon from '@/assets/icons/skip-forward.svg?react';
import { FC, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useCampaignsActions } from '../../../context';
import { CreateCampaignFormInput } from '../../../validation';
import { CampaignStepHeader, CampaignStepTitle } from '../../common';
import { CampaignStepHeaderProps } from '../../common/types';
import { BaseCampaignStep } from '../BaseCampaignStep';
import { DataSourceSection } from './DataSourceSection';

export const DataSourceStep: FC = () => {
  const { t } = useTranslation(['data_sources', 'ALL']);
  const { setNextStep } = useCampaignsActions();

  const { watch } = useFormContext<CreateCampaignFormInput>();
  const addedDataSources = watch('createdDataSources').length;

  const buttonConfig = useMemo(() => {
    let config: CampaignStepHeaderProps['primaryButton'] = {
      text: t('ALL:confirmDataSources'),
      onClick: setNextStep,
    };

    if (addedDataSources === 0) {
      config = {
        ...config,
        text: t('data_sources:buttons.skip_step'),
        className: '!py-2',
        intent: 'link-grey',
        size: 'lg',
        trailingIcon: <SkipForwardIcon />,
      };
    }

    return config;
  }, [addedDataSources]);

  return (
    <BaseCampaignStep>
      <CampaignStepHeader primaryButton={buttonConfig}>
        <CampaignStepTitle classNames={{ wrapper: 'mb-6' }} title='importDataSource_title' description='importDataSource_description' />
      </CampaignStepHeader>
      <DataSourceSection />
    </BaseCampaignStep>
  );
};
